import { i18n } from '@lingui/core'
import { I18nProvider as I18nProviderBase } from '@lingui/react'
import type { Locale } from '@skyground/contracts'
import { type PropsWithChildren, type ReactElement, useEffect, useState } from 'react'

import { dynamicActivate, getInitialLocale } from '../../shared/i18n/index.js'
import { I18nContext } from './context.js'

const initialLocale = getInitialLocale()

/**
 * Owns the active locale for the app and mirrors dashboard's provider so the shared auth screen
 * behaves identically. The initial (and each subsequently chosen) locale is activated in an effect
 * because vn-pwa loads catalogs lazily; lingui renders the English source until the chunk resolves.
 */
export function I18nProvider({ children }: PropsWithChildren): ReactElement {
  const [locale, setLocale] = useState<Locale>(initialLocale)

  useEffect(() => {
    void dynamicActivate(locale)
  }, [locale])

  return (
    <I18nProviderBase i18n={i18n}>
      <I18nContext.Provider value={{ initLocale: initialLocale, locale, setLocale }}>{children}</I18nContext.Provider>
    </I18nProviderBase>
  )
}
